import { useOrderPriceByDepartment } from "./useOrderPriceByDepartment";

export function usePaidAdvanceAmount(orderId: string | undefined): number | undefined {
  const { data } = useOrderPriceByDepartment(orderId);
  if (!data) {
    return undefined;
  }
  return Object.values(data.advance).reduce((sum, limits) => sum + (limits.amount - limits.availableAmount), 0);
}
